import { render } from "./customAnswerSheet.vue?vue&type=template&id=6d954f50&scoped=true"
import script from "./customAnswerSheet.vue?vue&type=script&lang=js"
export * from "./customAnswerSheet.vue?vue&type=script&lang=js"

import "./customAnswerSheet.vue?vue&type=style&index=0&id=6d954f50&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d954f50"]])

export default __exports__